import React, { useRef, useState } from "react";

const FloatingHeaderMenu = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const clickCountRef = useRef(0);
  const debugScroll = false;

  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) {
      clickCountRef.current += 1;
      const clickIndex = clickCountRef.current;
      const isMobile = window.matchMedia('(max-width: 767px)').matches;
      const offset = isMobile ? 80 : 200;
      const smoothScrollToTarget = () => {
        const startY = window.scrollY;
        const startTime = performance.now();
        const duration = 700;
        const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);
        const step = (now) => {
          const t = Math.min(1, (now - startTime) / duration);
          const targetY = el.getBoundingClientRect().top + window.pageYOffset - offset;
          const nextY = startY + (targetY - startY) * easeOutCubic(t);
          window.scrollTo({ top: nextY, behavior: 'auto' });
          if (t < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      };

      smoothScrollToTarget();

      if (debugScroll) {
        const rect = el.getBoundingClientRect();
        console.log('[scroll-debug:start]', {
          clickIndex,
          id,
          scrollY: window.scrollY,
          rectTop: rect.top,
          rectTopAbs: rect.top + window.pageYOffset,
        });
        requestAnimationFrame(() => {
          const rectAfter = el.getBoundingClientRect();
          console.log('[scroll-debug:raf]', {
            clickIndex,
            id,
            scrollY: window.scrollY,
            rectTop: rectAfter.top,
            rectTopAbs: rectAfter.top + window.pageYOffset,
          });
        });
        setTimeout(() => {
          const rectAfter = el.getBoundingClientRect();
          console.log('[scroll-debug:400ms]', {
            clickIndex,
            id,
            scrollY: window.scrollY,
            rectTop: rectAfter.top,
            rectTopAbs: rectAfter.top + window.pageYOffset,
          });
        }, 400);
      }
      setIsMenuOpen(false); // メニューを閉じる
    }
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const menuItems = [
    { id: "philosophy", label: "About" },
    { id: "performance", label: "Service" },
    { id: "message", label: "Message" },
    { id: "recruit", label: "Recruit" },
    { id: "company", label: "Company" },
    { id: "news", label: "News" },
    { id: "contact", label: "Contact" }
  ];

  return (
    <div>
      {isMenuOpen && (
        <div
          className="fixed inset-0 bg-black/50 backdrop-blur-sm z-40"
          onClick={toggleMenu}
        ></div>
      )}

      <div
        className={`fixed bottom-20 right-4 bg-orange-500 text-white p-4 rounded-lg shadow-lg z-50 w-36 transition-all duration-300 ease-in-out transform ${
          isMenuOpen
            ? "translate-y-0 scale-100 rotate-0 opacity-100 pointer-events-auto"
            : "translate-y-10 scale-75 rotate-[-10deg] opacity-0 pointer-events-none"
        }`}
      >
        <ul className="space-y-4">
          {menuItems.map((item) => (
            <li key={item.id} className="group relative">
              <button
                onClick={() => scrollToSection(item.id)}
                className="block relative text-lg font-medium pb-1 w-full text-left"
              >
                {item.label}
                <span className="absolute left-0 bottom-0 h-[2px] bg-white w-0 group-hover:w-full transition-all duration-300 ease-in-out"></span>
                <span className="absolute right-[-8px] bottom-[-4px] w-0 h-0 border-[6px] border-transparent border-l-white opacity-0 group-hover:opacity-100 transition-opacity duration-300 ease-in-out"></span>
              </button>
            </li>
          ))}
        </ul>
      </div>

      <button
        onClick={toggleMenu}
        className="fixed bottom-4 right-4 bg-white/70 text-black p-3 rounded-full shadow-lg focus:outline-none hover:bg-white/90 transition-all duration-300 z-50"
      >
        <div className="relative w-6 h-6">
          <span
            className={`absolute top-0 left-0 block w-6 h-1 bg-black rounded shadow-md transition-transform duration-300 ${
              isMenuOpen ? "transform rotate-45 translate-y-2.5" : ""
            }`}
          ></span>
          <span
            className={`absolute top-2.5 left-0 block w-6 h-1 bg-black rounded shadow-md transition-opacity duration-300 ${
              isMenuOpen ? "opacity-0" : "opacity-100"
            }`}
          ></span>
          <span
            className={`absolute bottom-0 left-0 block w-6 h-1 bg-black rounded shadow-md transition-transform duration-300 ${
              isMenuOpen ? "transform -rotate-45 -translate-y-2.5" : ""
            }`}
          ></span>
        </div>
      </button>
    </div>
  );
};

export default FloatingHeaderMenu;
